// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconLightning = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M55.1907 27.6888C48.0876 34.6287 39.6473 46.7507 35.58 58.4881C35.0182 60.1091 32.9864 60.5683 32 59.1645C31.7549 58.8157 28.6162 50.9218 28 39.9968L10.0253 40.0032C8.72999 40.0032 7.69562 38.7666 8.082 37.5304C12.1248 24.5961 24.6378 10.1106 34.7918 4.26738C36.4531 3.31139 38.612 5.09589 37.8378 6.82439C36.75 9.25288 34.3156 16.2059 34 24L54.112 24.0049C56.0969 24.0049 56.6169 26.2953 55.1907 27.6888Z" />
    </svg>
  );
};
